export const FONT_WEIGHT = {
  NORMAL: 400,
  SEMI_BOLD: 600,
  BOLD: 700
};

export const FONT_SIZE = {
  XXS: '10px',
  XS: '12px',
  SM: '14px',
  MD: '16px',
  LG: '18px',
  XL: '20px',
  XXL: '22px',
  XXXL: '24px',
  XXXXL: '32px',
  HUGE: '48px'
};

export const SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
export const VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DEFAULT: 'default'
};
export const MODAL_TYPE = {
  FLUID: 'fluid',
  LARGE: 'L',
  SMALL: 'S',
  MEDIUM: 'M'
};
export const UPLOAD_TYPE = {
  SINGLE: 'single',
  MULTIPLE: 'multiple'
};

export const FEEDBACK_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

export const ORIENTATION = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
